import { Component, input } from '@angular/core';

@Component({
  selector: 'app-page-section-card',
  imports: [],
  templateUrl: './page-section-card.html',
  styleUrl: './page-section-card.scss',
})
export class PageSectionCard {
  img = input<string>('assets/page-section-card-1.jpg')
  title = input<string>('Título')
  description = input<string>('Descripcion')
  link = input<string>('https://wolfavionic.com')


}
